import { Tooltip, Box } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'

type VerticalGaugeProps = {
  percentUsed: number
  hasValue: boolean
  accentColor: string
  borderColor: string
  tooltipLabel?: ReactNode
}

export const VerticalGauge: FC<VerticalGaugeProps> = ({
  percentUsed,
  hasValue,
  accentColor,
  borderColor,
  tooltipLabel
}) => {
  const gauge = (
    <Box
      position="relative"
      width="8px"
      height="120px"
      borderRadius="4px"
      border={`1px solid ${borderColor}`}
      overflow="hidden"
      backgroundColor="white"
      cursor={tooltipLabel ? 'help' : undefined}
      flexShrink={0}
    >
      {hasValue && (
        <Box
          position="absolute"
          bottom={0}
          left={0}
          right={0}
          backgroundColor={accentColor}
          transition="height 200ms ease"
          style={{ height: `${percentUsed}%` }}
        />
      )}
    </Box>
  )

  if (tooltipLabel === undefined) return gauge

  return (
    <Tooltip label={tooltipLabel} placement="right" hasArrow>
      {gauge}
    </Tooltip>
  )
}
